import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const CorporateLaw = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  return (
    <div className="practice-page">
         <ScrollToTop/>
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>
      
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li key={index} className={category === "Corporate Law" ? "active" : ""}>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>
      
      <main className="conten">
        <h2>Corporate Law</h2>
        <p className="intro">
          At InduratnaLaw, our Corporate Law practice offers in-depth legal advice and strategic support to businesses of all sizes. We help you navigate complexities in corporate governance, mergers and acquisitions, and regulatory compliance.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            Our seasoned attorneys provide thorough legal insight for corporate restructuring, governance, and compliance, ensuring your business is protected and strategically positioned for success.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Corporate Governance and Compliance</li>
            <li>Mergers, Acquisitions & Restructuring</li>
            <li>Contract Negotiation and Drafting</li>
            <li>Risk Management and Litigation Support</li>
            <li>Shareholder Agreements</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            We combine legal expertise with business acumen to offer comprehensive corporate law solutions that secure your business interests and foster growth.
          </p>
        </section>
      </main>
      <HeroFooter />
    </div>
  );
};

export default CorporateLaw;
